import React, { useState, useEffect } from "react";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Select, { components } from "react-select";

const indianStates = [
  { value: "ALL", label: "All India" },
  { value: "AP", label: "Andhra Pradesh" },
  { value: "AR", label: "Arunachal Pradesh" },
  { value: "AS", label: "Assam" },
  { value: "BR", label: "Bihar" },
  { value: "CT", label: "Chhattisgarh" },
  { value: "GA", label: "Goa" },
  { value: "GJ", label: "Gujarat" },
  { value: "HR", label: "Haryana" },
  { value: "HP", label: "Himachal Pradesh" },
  { value: "JH", label: "Jharkhand" },
  { value: "KA", label: "Karnataka" },
  { value: "KL", label: "Kerala" },
  { value: "MP", label: "Madhya Pradesh" },
  { value: "MH", label: "Maharashtra" },
  { value: "MN", label: "Manipur" },
  { value: "ML", label: "Meghalaya" },
  { value: "MZ", label: "Mizoram" },
  { value: "NL", label: "Nagaland" },
  { value: "OR", label: "Odisha" },
  { value: "PB", label: "Punjab" },
  { value: "RJ", label: "Rajasthan" },
  { value: "SK", label: "Sikkim" },
  { value: "TN", label: "Tamil Nadu" },
  { value: "TS", label: "Telangana" },
  { value: "TR", label: "Tripura" },
  { value: "UP", label: "Uttar Pradesh" },
  { value: "UK", label: "Uttarakhand" },
  { value: "WB", label: "West Bengal" },
  { value: "AN", label: "Andaman and Nicobar Islands" },
  { value: "CH", label: "Chandigarh" },
  { value: "DN", label: "Dadra and Nagar Haveli and Daman and Diu" },
  { value: "DL", label: "Delhi" },
  { value: "JK", label: "Jammu and Kashmir" },
  { value: "LA", label: "Ladakh" },
  { value: "LD", label: "Lakshadweep" },
  { value: "PY", label: "Puducherry" },
];

const CustomOption = (props) => (
  <components.Option {...props}>
    <input type="checkbox" checked={props.isSelected} onChange={() => null} style={{ marginRight: 8 }} />
    {props.label}
  </components.Option>
);

const ServiceTeamEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    experience: "",
    pan_card: "",
    aadhar_card: "",
    category_id: "", // level1 id (single)
    about: "",
    phone_whatsapp: "",
    phone_alternate: "",
    // You can add more fields if backend requires them
  });

  // file states
  const [resumeFiles, setResumeFiles] = useState([]);
  const [profileImages, setProfileImages] = useState([]);

  // Level states: options are arrays of {value,label}, selectedLevelX are arrays (except level1)
  const [selectedLevel1, setSelectedLevel1] = useState("");
  const [level2Options, setLevel2Options] = useState([]);
  const [selectedLevel2, setSelectedLevel2] = useState([]);
  const [level3Options, setLevel3Options] = useState([]);
  const [selectedLevel3, setSelectedLevel3] = useState([]);
  const [level4Options, setLevel4Options] = useState([]);
  const [selectedLevel4, setSelectedLevel4] = useState([]);

  // states multiselect
  const [selectedStates, setSelectedStates] = useState([]);

  // Build a parent map helper when categories fetched
  const buildParentMap = (allCats) => {
    const map = {};
    allCats.forEach((cat) => {
      const pid = cat.parent_id ?? 0; // ensure undefined => 0
      if (!map[pid]) map[pid] = [];
      map[pid].push({ value: cat.id, label: cat.service_title });
    });
    return map;
  };

  useEffect(() => {
    const fetchCategoriesAndData = async () => {
      try {
        const res = await axios.get(`${baseurl}getAllServiceCategories`);
        const allCats = res.data.data || [];
        allCats.sort((a, b) => a.service_title.localeCompare(b.service_title));
        setCategories(allCats);

        const parentMap = buildParentMap(allCats);

        // if editing existing user
        if (id) {
          const res2 = await axios.get(`${baseurl}getServiceManById/${id}`);
          const man = res2.data.data || {};

          // set only the visible form fields (do not overwrite internal control states)
          setFormData((prev) => ({
            ...prev,
            name: man.name || prev.name,
            phone: man.phone || prev.phone,
            phone_alternate: man.phone_alternate || prev.phone_alternate,
            phone_whatsapp: man.phone_whatsapp || prev.phone_whatsapp,
            email: man.email || prev.email,
            experience: man.experience || prev.experience,
            pan_card: man.pan_card || prev.pan_card,
            aadhar_card: man.aadhar_card || prev.aadhar_card,
            about: man.about || prev.about,
            // do not set category fields here; we will set via selectedLevelX below
          }));

          // Parse stored category path (comma separated ids) -> numbers
          const categoryIds = man.category_id
            ? man.category_id
                .toString()
                .split(",")
                .map((v) => parseInt(v))
                .filter((n) => !Number.isNaN(n))
            : [];

          // If there's a path, populate levels
          if (categoryIds.length > 0) {
            // Level1
            const lvl1 = categoryIds[0];
            setSelectedLevel1(lvl1);

            // Level2 options from parentMap[lvl1]
            const lvl2Opts = parentMap[lvl1] ?? [];
            setLevel2Options(lvl2Opts);

            // selected level2 -> from categoryIds
            const lvl2Selected = lvl2Opts.filter((o) => categoryIds.includes(o.value));
            setSelectedLevel2(lvl2Selected);

            // Level3 options come from children of selected level2
            const lvl3Opts = lvl2Selected.flatMap((sel) => parentMap[sel.value] ?? []);
            setLevel3Options(lvl3Opts);

            const lvl3Selected = lvl3Opts.filter((o) => categoryIds.includes(o.value));
            setSelectedLevel3(lvl3Selected);

            // Level4 options come from children of selected level3
            const lvl4Opts = lvl3Selected.flatMap((sel) => parentMap[sel.value] ?? []);
            setLevel4Options(lvl4Opts);

            const lvl4Selected = lvl4Opts.filter((o) => categoryIds.includes(o.value));
            setSelectedLevel4(lvl4Selected);
          }

          // parse selected_states possibly stored as comma separated string like "UP,PB,HP"
          if (man.selected_states) {
            const stateIds = man.selected_states
              .toString()
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
            const selectedStateObjs = indianStates.filter((s) => stateIds.includes(s.value));
            setSelectedStates(selectedStateObjs);
          }
        }
      } catch (err) {
        console.error("Error loading categories or profile", err);
      }
    };

    fetchCategoriesAndData();
  }, [id]);

  // handle simple form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (["phone", "phone_alternate", "phone_whatsapp"].includes(name)) {
      const sanitized = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({ ...prev, [name]: sanitized }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleFileChange = (e, type) => {
    const files = Array.from(e.target.files);
    if (type === "resume") setResumeFiles(files);
    if (type === "profileImage") setProfileImages(files);
  };

  // central level change handler
  const handleLevelChange = (selected, level) => {
    // level 1 is native select (event passed)
    if (level === 1) {
      const rawVal = selected.target?.value ?? "";
      const val = rawVal === "" ? "" : parseInt(rawVal, 10);
      setSelectedLevel1(val);
      setFormData((prev) => ({ ...prev, category_id: val || "" }));

      // update level2 options
      const lvl2 = categories
        .filter((cat) => cat.parent_id === val)
        .map((cat) => ({ value: cat.id, label: cat.service_title }));
      setLevel2Options(lvl2);

      // reset deeper levels
      setSelectedLevel2([]);
      setLevel3Options([]);
      setSelectedLevel3([]);
      setLevel4Options([]);
      setSelectedLevel4([]);
      setSelectedStates([]);
      setFormData((prev) => ({ ...prev, selected_states: "" }));
      return;
    }

    // levels 2-4: react-select passes array or null
    const arr = Array.isArray(selected) ? selected : [];
    const normalized = arr.map((s) => ({ value: s.value, label: s.label }));

    if (level === 2) {
      setSelectedLevel2(normalized);
      setFormData((prev) => ({ ...prev, category_ids: normalized.map((s) => s.value).join(",") }));

      // compute next-level (level3) options: children where parent_id is any selected level2 value
      const lvl3 = categories
        .filter((cat) => normalized.some((sel) => sel.value === cat.parent_id))
        .map((cat) => ({ value: cat.id, label: cat.service_title }));
      setLevel3Options(lvl3);

      // clear deeper levels
      setSelectedLevel3([]);
      setLevel4Options([]);
      setSelectedLevel4([]);
      setSelectedStates([]);
      setFormData((prev) => ({ ...prev, sub_category_ids: "", sub_sub_category_ids: "", selected_states: "" }));
      return;
    }

    if (level === 3) {
      setSelectedLevel3(normalized);
      setFormData((prev) => ({ ...prev, sub_category_ids: normalized.map((s) => s.value).join(",") }));

      // compute level4 options from selected level3
      const lvl4 = categories
        .filter((cat) => normalized.some((sel) => sel.value === cat.parent_id))
        .map((cat) => ({ value: cat.id, label: cat.service_title }));
      setLevel4Options(lvl4);

      // clear deeper selections
      setSelectedLevel4([]);
      setSelectedStates([]);
      setFormData((prev) => ({ ...prev, sub_sub_category_ids: "", selected_states: "" }));
      return;
    }

    if (level === 4) {
      setSelectedLevel4(normalized);
      setFormData((prev) => ({ ...prev, sub_sub_category_ids: normalized.map((s) => s.value).join(",") }));

      // when level4 selected, states become available. Don't clear states here.
      return;
    }
  };

  // ensure that if options change (due to user selecting something) selected arrays contain only available options
  useEffect(() => {
    if (level2Options.length > 0 && selectedLevel2.length > 0) {
      const filtered = selectedLevel2.filter((sel) => level2Options.some((opt) => opt.value === sel.value));
      if (filtered.length !== selectedLevel2.length) setSelectedLevel2(filtered);
    }
  }, [level2Options]); // eslint-disable-line

  useEffect(() => {
    if (level3Options.length > 0 && selectedLevel3.length > 0) {
      const filtered = selectedLevel3.filter((sel) => level3Options.some((opt) => opt.value === sel.value));
      if (filtered.length !== selectedLevel3.length) setSelectedLevel3(filtered);
    }
  }, [level3Options]); // eslint-disable-line

  useEffect(() => {
    if (level4Options.length > 0 && selectedLevel4.length > 0) {
      const filtered = selectedLevel4.filter((sel) => level4Options.some((opt) => opt.value === sel.value));
      if (filtered.length !== selectedLevel4.length) setSelectedLevel4(filtered);
    }
  }, [level4Options]); // eslint-disable-line

  // submit handler
const handleUpdate = async (e) => {
  e.preventDefault();

  // Build final category path
  const allCategoryIds = [
    selectedLevel1 || "",
    ...(selectedLevel2?.map((i) => i.value) || []),
    ...(selectedLevel3?.map((i) => i.value) || []),
    ...(selectedLevel4?.map((i) => i.value) || []),
  ].filter(Boolean);

  const selectedStateIds = (selectedStates || []).map((s) => s.value);

  const data = new FormData();

  // Remove category_id from old formData
  const filteredFormData = { ...formData };
  delete filteredFormData.category_id;
  delete filteredFormData.category_new; // ensure no duplicates

  // Append existing form fields
  Object.entries(filteredFormData).forEach(([k, v]) => {
    if (v !== undefined && v !== null) data.append(k, v);
  });

  // ✔ Backend expects category_new
  data.append("category_new", allCategoryIds.join(","));
  data.append("seller_id", localStorage.getItem("seller_id"));

  // ✔ Backend expects comma-separated string
  data.append("selected_states", selectedStateIds.join(","));

  // Files
  resumeFiles.forEach((file) => data.append("resume", file));
  profileImages.forEach((file) => data.append("profile_image", file));

  console.log("🔍 SENT FORM DATA:");
  for (let pair of data.entries()) {
    console.log(pair[0], ":", pair[1]);
  }

  try {
    const response = await axios.post(
      `${baseurl}updateServiceManById/${id}`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    console.log("🔍 RESPONSE:", response.data);

    await Swal.fire({
      icon: "success",
      title: "Updated!",
      text: "Service man updated successfully!",
      timer: 1800,
      showConfirmButton: false,
    });

    navigate(-1);

  } catch (err) {
    console.log("❌ ERROR:", err.response?.data);

    await Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Failed to update profile.",
    });
  }
};

  return (
    <>
      <SellerNavbar />
      <div className="container-fluid">
        <div className="row my-3 g-2">
          <div className="col-md-2">
            <SellerSidebar />
          </div>

          <div className="col-md-10 text-start">
            <div className="card p-4">
              <h4 className="mb-4">Edit Service Man Profile</h4>

              <form onSubmit={handleUpdate} encType="multipart/form-data">
                <div className="row g-3">
                  {/* Name */}
                  <div className="col-md-12">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Name"
                      required
                    />
                  </div>

                  {/* About */}
                  <div className="col-md-12">
                    <textarea
                      name="about"
                      value={formData.about}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Write About Yourself"
                      rows={4}
                      required
                    />
                  </div>

                  {/* Phone fields */}
                  <div className="col-md-6">
                    <input type="text" name="phone" value={formData.phone} onChange={handleChange} className="form-control" placeholder="Phone Number" required />
                  </div>

                  <div className="col-md-6">
                    <input type="text" name="phone_alternate" value={formData.phone_alternate} onChange={handleChange} className="form-control" placeholder="Alternate Phone Number" />
                  </div>

                  <div className="col-md-6">
                    <input type="text" name="phone_whatsapp" value={formData.phone_whatsapp} onChange={handleChange} className="form-control" placeholder="Whatsapp Number" />
                  </div>

                  {/* Email */}
                  <div className="col-md-6">
                    <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" placeholder="Email" />
                  </div>

                  {/* Experience / PAN / Aadhar */}
                  <div className="col-md-4">
                    <input type="text" name="experience" value={formData.experience} onChange={handleChange} className="form-control" placeholder="Experience (e.g. 2 years)" />
                  </div>
                  <div className="col-md-4">
                    <input type="text" name="pan_card" value={formData.pan_card} onChange={handleChange} className="form-control" placeholder="PAN Card Number" />
                  </div>
                  <div className="col-md-4">
                    <input type="text" name="aadhar_card" value={formData.aadhar_card} onChange={handleChange} className="form-control" placeholder="Aadhar Card Number" />
                  </div>

                  {/* Level 1 - native select */}
                  <div className="col-md-4">
                    <label className="form-label">What We Do</label>
                    <select className="form-select" value={selectedLevel1 || ""} onChange={(e) => handleLevelChange(e, 1)}>
                      <option value="">Select What We Do</option>
                      {categories
                        .filter((cat) => !cat.parent_id) // root categories
                        .map((cat) => (
                          <option key={cat.id} value={cat.id}>
                            {cat.service_title}
                          </option>
                        ))}
                    </select>
                  </div>

                  {/* Level 2 */}
                  {level2Options.length > 0 && (
                    <div className="col-md-4">
                      <label className="form-label">Category</label>
                      <Select
                        isMulti
                        closeMenuOnSelect={false}
                        options={level2Options}
                        value={selectedLevel2}
                        onChange={(e) => handleLevelChange(e, 2)}
                        components={{ Option: CustomOption }}
                      />
                    </div>
                  )}

                  {/* Level 3 */}
                  {level3Options.length > 0 && (
                    <div className="col-md-4">
                      <label className="form-label">Sub Category</label>
                      <Select
                        isMulti
                        closeMenuOnSelect={false}
                        options={level3Options}
                        value={selectedLevel3}
                        onChange={(e) => handleLevelChange(e, 3)}
                        components={{ Option: CustomOption }}
                      />
                    </div>
                  )}

                  {/* Level 4 */}
                  {level4Options.length > 0 && (
                    <div className="col-md-4">
                      <label className="form-label">Sub Sub Sub Category</label>
                      <Select
                        isMulti
                        closeMenuOnSelect={false}
                        options={level4Options}
                        value={selectedLevel4}
                        onChange={(e) => handleLevelChange(e, 4)}
                        components={{ Option: CustomOption }}
                      />
                    </div>
                  )}

                  {/* States */}
                  {selectedLevel4 && selectedLevel4.length > 0 && (
                    <div className="col-md-4">
                      <label className="form-label">Select State(s)</label>
                      <Select isMulti closeMenuOnSelect={false} options={indianStates} value={selectedStates} onChange={(e) => setSelectedStates(Array.isArray(e) ? e : [])} components={{ Option: CustomOption }} />
                    </div>
                  )}

                  {/* Resume Upload */}
                  <div className="col-md-12">
                    <label className="form-label">Upload Resume(s)</label>
                    <input type="file" multiple accept=".pdf" onChange={(e) => handleFileChange(e, "resume")} className="form-control" />
                    <ul>
                      {resumeFiles.map((file, i) => (
                        <li key={i}>{file.name}</li>
                      ))}
                    </ul>
                  </div>

                  {/* Profile Image Upload */}
                  <div className="col-md-12">
                    <label className="form-label">Upload Profile Image(s)</label>
                    <input type="file" multiple accept="image/*" onChange={(e) => handleFileChange(e, "profileImage")} className="form-control" />
                    <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
                      {profileImages.map((file, i) => (
                        <img key={i} src={URL.createObjectURL(file)} alt="preview" width={60} height={60} style={{ objectFit: "cover", borderRadius: 6 }} />
                      ))}
                    </div>
                  </div>

                  <div className="col-12 mt-3">
                    <button type="submit" className="btn btn-primary w-100">
                      Submit Profile
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceTeamEdit;
